import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "deals",
    defaultRoutePath: "/partnershipDeals/deal",
    menuItemScope: "partnershipDeals",
    menuItemName: "deals",

    routes: [
        {
            path: "/partnershipDeals/deal",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Wizards.Create,
        },
    ],

}

export default Module;
